import {eatalianoAxios} from "@/data/api/http/axios";
import {Menu, ProductStock} from "@/data/entities/menu";

export const getMenu = (restaurantId: number): Promise<Menu> => (
    eatalianoAxios
        .get(`/restaurant/${restaurantId}/menu`)
        .then(response => response.data)
);

/**
 * Marks a product as sold out or in stock (POS).
 */
export const updateProductStock = (
    restaurantId: number,
    productId: number,
    soldout: boolean,
): Promise<ProductStock> => (
    eatalianoAxios
        .put<ProductStock>(`/restaurant/${restaurantId}/products/${productId}/stock`, {soldout})
        .then(response => response.data)
);